module.exports = __webpack_public_path__ + "img/copy-white.6c7a7b56.png";